import Vue from "vue";
import Router from "vue-router";
import { VueInstance } from "./main";
import Store, { vuex } from "./store";
import LandingPage from "./views/LandingPage.vue";
import Freebies from "./views/Freebies.vue";
import Account from "./views/Account.vue";
import GdprApproval from "./views/GdprApproval.vue";
import AiApproval from "./views/AiApproval.vue";
import Gdpr from "./views/Gdpr.vue";
import Imprint from "./views/Imprint.vue";
import TermsOfUse from "./views/TermsOfUse.vue";
import Home from "./views/Home.vue";
import Admin from "./views/Admin.vue";
import UserManagementView from "./views/UserManagementView.vue";
import ManageTopicNotifications from "./views/ManageTopicNotifications.vue";
import OrganizationView from "./views/OrganizationView.vue";
import GroupsView from "./views/GroupsView.vue";
import UsersView from "./views/UsersView.vue";
import CoursesSummaryView from "./views/CoursesSummaryView.vue";
import SurveysView from "./views/SurveysView.vue";
import SurveyEvaluationView from "./views/SurveyEvaluationView.vue";
import MyExercisesView from "./views/MyExercisesView.vue";
import MyCertificatesView from "./views/MyCertificatesView.vue";
import GroupExerciseOverview from "./views/GroupExerciseOverview.vue";
import ExerciseBundleView from "./views/ExerciseBundleView.vue";
// import ExerciseCatalog from "./views/ExerciseCatalog.vue";
import Exercise from "./views/Exercise.vue";
import ContentManager from "./views/ContentManager.vue";
import ContentCreatorView from "./views/ContentCreatorView.vue";
import ContentCreatorBundleView from "./views/ContentCreatorBundleView.vue";
import CourseApprovalView from "./views/CourseApprovalView.vue";
import ExerciseAssignment from "./views/ExerciseAssignment.vue";
import UserPerformanceOverview from "./views/UserPerformanceOverview.vue";
import GroupPerformanceOverview from "./views/GroupPerformanceOverview.vue";
// import About from "./views/About.vue";
import ContentCreationHelp from "./views/ContentCreationHelp.vue";
import ToolsView from "./views/ToolsView.vue";
import { delay } from "lodash";
import CustomerSettingsView from "./views/CustomerSettingsView.vue";
import AiStockMarketAgentView from "./views/AiStockMarketAgentView.vue";

Vue.use(Router);

const redirectToHome = (nextCallback?: Function) => {
  if (router.currentRoute.path === "/") {
    if (nextCallback) nextCallback();
    return;
  }

  router.push("/");
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "landingPage",
      component: LandingPage,
    },
    {
      path: "/freebies",
      name: "freebies",
      component: Freebies,
    },
    {
      path: "/account",
      name: "account",
      component: Account,
    },
    {
      path: "/gdprApproval",
      name: "gdprApproval",
      component: GdprApproval,
    },
    {
      path: "/gdpr",
      name: "gdpr",
      component: Gdpr,
    },
    {
      path: "/imprint",
      name: "imprint",
      component: Imprint,
    },
    {
      path: "/termsOfUse",
      name: "termsOfUse",
      component: TermsOfUse,
    },
    {
      path: "/aiApproval",
      name: "aiApproval",
      component: AiApproval,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isContentManager"] ||
          VueInstance.$store.getters["auth/isNotificationAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isLearner"]
          // VueInstance.$store.getters["auth/isParent"] ||
          // VueInstance.$store.getters["auth/isPupil"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/admin",
      name: "admin",
      component: Admin,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"]) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/customerSettings",
      name: "customerSettings",
      component: CustomerSettingsView,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"]) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/aiStockMarketAgent",
      name: "aiStockMarketAgent",
      component: AiStockMarketAgentView,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"]) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/userManagement",
      name: "userManagement",
      component: UserManagementView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"]
        ) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/notifications",
      name: "notifications",
      component: ManageTopicNotifications,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isNotificationAdmin"]
        ) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/organizations",
      name: "organizations",
      component: OrganizationView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/groups",
      name: "groups",
      component: GroupsView,
      beforeEnter: (to, from, next) => {
        // console.log("isAdmin: ", vuex.auth.isAdmin);
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        // console.log("/groups not authorized");
        redirectToHome(next);
      },
    },
    {
      path: "/users",
      name: "users",
      component: UsersView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/coursesSummary",
      name: "coursesSummary",
      component: CoursesSummaryView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isGroupViewer"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/surveys",
      name: "surveys",
      component: SurveysView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/surveyEvaluation",
      name: "surveyEvaluation",
      component: SurveyEvaluationView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/myExercises",
      name: "myExercises",
      component: MyExercisesView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/myCertificates",
      name: "myCertificates",
      component: MyCertificatesView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/GroupExerciseOverview",
      name: "groupExerciseOverview",
      component: GroupExerciseOverview,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isGroupViewer"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/exerciseBundle",
      name: "exerciseBundle",
      component: ExerciseBundleView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isGroupViewer"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/courseApproval",
      name: "courseApproval",
      component: CourseApprovalView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isContentManager"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/exerciseAssignment",
      name: "exerciseAssignment",
      component: ExerciseAssignment,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/exercise",
      name: "exercise",
      component: Exercise,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/userPerformanceOverview",
      name: "userPerformanceOverview",
      component: UserPerformanceOverview,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/groupPerformanceOverview",
      name: "groupPerformanceOverview",
      component: GroupPerformanceOverview,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"]
        )
          return next();
        redirectToHome(next);
      },
    },
    {
      path: "/contentManager",
      name: "contentManager",
      component: ContentManager,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isContentManager"]
        ) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/contentCreator",
      name: "contentCreator",
      component: ContentCreatorView,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isContentManager"]
        ) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/contentBundle",
      name: "contentBundle",
      component: ContentCreatorBundleView,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isContentManager"]
        ) return next();
        redirectToHome(next);
      },
    },
    {
      path: "/contentCreationHelp",
      name: "contentCreationHelp",
      component: ContentCreationHelp,
      beforeEnter: (to, from, next) => {
        if (VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isContentManager"]
        ) return next();
        redirectToHome(next);
      },
    },
    // {
    //   path: "/about",
    //   name: "about",
    //   component: About,
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   //component: () => import(/* webpackChunkName: "about" */ "./views/About.vue"),
    // },
    {
      // Only for demonstration purposes, not for production use
      path: "/tools",
      name: "tools",
      component: ToolsView,
      beforeEnter: (to, from, next) => {
        if (
          VueInstance.$store.getters["auth/isAdmin"] ||
          VueInstance.$store.getters["auth/isOrgAdmin"] ||
          VueInstance.$store.getters["auth/isGroupAdmin"] ||
          VueInstance.$store.getters["auth/isTrainingLead"] ||
          VueInstance.$store.getters["auth/isLearner"]
        )
          return next();
        redirectToHome(next);
      },
    },
  ],
  scrollBehavior() {
    document.getElementById("app")?.scrollIntoView({ behavior: "smooth" });
  },
});

// */
// Navigation Guards
// in order of lifecycle
// */

router.beforeResolve((to, from, next) => {
  if (to.name) {
    VueInstance.$wait.start("router");
  }
  next();
});

router.beforeEach((to, from, next) => {
  function proceed() {
    // console.log("Store.state: " + vuex.ux.ready);
    if (!vuex.ux.ready) return;
    // console.log("from: " + from.name);
    // console.log("to: " + to.name);

    if (to.name != "gdprApproval" && (VueInstance?.$store.state.auth.portalUser?.gdprApprovalRequired ?? false)) {
      if (router.currentRoute.path !== "/gdprApproval") router.push("/gdprApproval");
      // console.log("From: " + from.name  +" => To: " + to.name);
    }
    if (from.name == "home" && to.name != "home") {
      // VueInstance.$store.dispatch("notify/topicNotificationsNoted");
      vuex.notify.topicNotificationsNoted();
    }
    if (
      !vuex.auth.loggedIn &&
      to.name != "landingPage" &&
      to.name != "freebies" &&
      to.name != "account" &&
      to.name != "gdprApproval" && // TODO: Should be only accessible to authenticated users
      to.name != "gdpr" &&
      to.name != "imprint" &&
      to.name != "termsOfUse"
    ) return;
    next();
  }
  if (!vuex.ux.ready) {
    vuex.ux.$watch('isReady', (value: boolean) => {
      if (value === true) {
        proceed();
      }
    })
  }
  if (!vuex.auth.loggedIn) {
    vuex.auth.$watch('loggedIn', (value: boolean) => {
      if (value === true) {
        // console.log("logged in");
        proceed();
      }
    })
  }
  proceed();
});

router.afterEach((to, from) => {
  VueInstance.$wait.end("router");
});

export default router;
